(function() {
  'use strict';

  var COOKIE_NAME = 'cv_location';
  var COOKIE_DAYS = 3650;
  var GT_OFFSET = -6;

  var _xelaTextOriginal = null;

  function _updateXelaTexts() {
    document.querySelectorAll('[data-xela-badge-text]').forEach(function(el) {
      if (!el.getAttribute('data-xela-original')) {
        el.setAttribute('data-xela-original', el.textContent.trim());
      }
      var original = el.getAttribute('data-xela-original');
      if (document.documentElement.classList.contains('cv-xela-green')) {
        el.textContent = original.replace(/\s*\(24\s*hr\)\s*/i, '').replace(/\s*24\s*hr\s*/i, '').trim();
      } else {
        el.textContent = original;
      }
    });
  }

  function _handleDualContainers(dept, zone) {
    var isXelaZone = zone === 'messenger_xela';
    document.querySelectorAll('.xela-stock-dual').forEach(function(dual) {
      var stockGt = dual.getAttribute('data-stock-gt') === 'true';
      var stockEl = dual.querySelector('.xela-stock-dual__stock');
      var xelaEl = dual.querySelector('.xela-stock-dual__xela');
      if (!stockEl || !xelaEl) return;
      if (isXelaZone) {
        stockEl.style.setProperty('display', 'none', 'important');
        xelaEl.style.setProperty('display', 'inline-flex', 'important');
      } else if (stockGt) {
        stockEl.style.setProperty('display', 'inline-flex', 'important');
        xelaEl.style.setProperty('display', 'none', 'important');
      } else {
        stockEl.style.setProperty('display', 'none', 'important');
        xelaEl.style.setProperty('display', 'inline-flex', 'important');
      }
    });
  }

  function _resetDualContainers() {
    document.querySelectorAll('.xela-stock-dual').forEach(function(dual) {
      var stockEl = dual.querySelector('.xela-stock-dual__stock');
      var xelaEl = dual.querySelector('.xela-stock-dual__xela');
      if (stockEl) stockEl.style.removeProperty('display');
      if (xelaEl) xelaEl.style.removeProperty('display');
    });
  }

  function _handleGtOnlyBadges(zone) {
    var isXelaZone = zone === 'messenger_xela';
    document.querySelectorAll('[data-gt-only="true"]').forEach(function(badge) {
      var textEl = badge.querySelector('.stock-badge-text');
      var iconEl = badge.querySelector('.stock-icon-svg');
      if (!textEl) return;
      if (isXelaZone) {
        if (!badge.getAttribute('data-gt-only-original')) {
          badge.setAttribute('data-gt-only-original', textEl.textContent.trim());
        }
        textEl.textContent = 'Envío desde Guate';
        badge.classList.add('product-label--gt-only');
        if (iconEl) iconEl.style.setProperty('display', 'none', 'important');
      } else {
        var orig = badge.getAttribute('data-gt-only-original');
        if (orig) textEl.textContent = orig;
        badge.classList.remove('product-label--gt-only');
        if (iconEl) iconEl.style.removeProperty('display');
      }
    });
  }

  function _resetGtOnlyBadges() {
    document.querySelectorAll('[data-gt-only="true"]').forEach(function(badge) {
      var textEl = badge.querySelector('.stock-badge-text');
      var iconEl = badge.querySelector('.stock-icon-svg');
      if (!textEl) return;
      var orig = badge.getAttribute('data-gt-only-original');
      if (orig) textEl.textContent = orig;
      badge.classList.remove('product-label--gt-only');
      if (iconEl) iconEl.style.removeProperty('display');
    });
  }

  function _resetStandaloneXelaBadges() {
    document.querySelectorAll('[data-xela-badge][data-stock-gt]').forEach(function(badge) {
      if (badge.closest('.xela-stock-dual')) return;
      badge.style.removeProperty('display');
    });
  }

  function _handleStandaloneXelaBadges(dept) {
    var isGuatemala = dept === 'guatemala';
    document.querySelectorAll('[data-xela-badge][data-stock-gt]').forEach(function(badge) {
      if (badge.closest('.xela-stock-dual')) return;
      var stockGt = badge.getAttribute('data-stock-gt') === 'true';
      if (isGuatemala && stockGt) {
        badge.style.setProperty('display', 'none', 'important');
      } else {
        badge.style.removeProperty('display');
      }
    });
  }

  // Marca "ubicación exacta" (GPS o pin en el mapa), distinta de elegir sólo
  // departamento/municipio en el selector del header (loc.precise === false).
  function applyExactLocationClass(loc) {
    var root = document.documentElement;
    if (loc && loc.confirmed && loc.precise) {
      root.classList.add('cv-has-exact-location');
    } else {
      root.classList.remove('cv-has-exact-location');
    }
  }

  function applyXelaBadgeLogic(loc) {
    var root = document.documentElement;
    root.classList.remove('cv-xela-green', 'cv-xela-local');
    applyExactLocationClass(loc);
    if (!loc || !loc.confirmed) {
      root.classList.remove('cv-has-location');
      _resetDualContainers();
      _resetStandaloneXelaBadges();
      _resetGtOnlyBadges();
      _updateXelaTexts();
      return;
    }
    root.classList.add('cv-has-location');
    var dept = (loc.dept || '').toLowerCase().trim();
    var zone = (loc.zone || '').toLowerCase().trim();
    if (dept === 'guatemala') {
      _handleDualContainers(dept, zone);
      _handleStandaloneXelaBadges(dept);
      _handleGtOnlyBadges(zone);
      _updateXelaTexts();
      return;
    }
    root.classList.add('cv-xela-green');
    if (zone === 'messenger_xela') {
      root.classList.add('cv-xela-local');
    }
    _handleDualContainers(dept, zone);
    _handleStandaloneXelaBadges(dept);
    _handleGtOnlyBadges(zone);
    _updateXelaTexts();
  }

  var _xelaObserverTimer = null;
  if (typeof MutationObserver !== 'undefined') {
    var _xelaObserver = new MutationObserver(function(mutations) {
      var root = document.documentElement;
      var hasLocation = root.classList.contains('cv-has-location');
      var isLocal = root.classList.contains('cv-xela-local');
      if (!hasLocation && !isLocal) return;
      var hasNew = false;
      for (var i = 0; i < mutations.length && !hasNew; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType === 1) {
            if ((node.hasAttribute && (node.hasAttribute('data-xela-badge-text') || node.hasAttribute('data-xela-badge') || node.classList.contains('xela-stock-dual') || node.hasAttribute('data-gt-only'))) ||
                (node.querySelector && (node.querySelector('[data-xela-badge-text]') || node.querySelector('.xela-stock-dual') || node.querySelector('[data-gt-only]')))) {
              hasNew = true;
              break;
            }
          }
        }
      }
      if (hasNew) {
        if (_xelaObserverTimer) clearTimeout(_xelaObserverTimer);
        _xelaObserverTimer = setTimeout(function() {
          try {
            var match = document.cookie.match('(?:^|;)\\s*' + COOKIE_NAME + '=([^;]*)');
            if (match) {
              var d = JSON.parse(decodeURIComponent(match[1]));
              if (d && d.confirmed) {
                var dept = (d.dept || '').toLowerCase().trim();
                var zone = (d.zone || '').toLowerCase().trim();
                _handleDualContainers(dept, zone);
                _handleStandaloneXelaBadges(dept);
                _handleGtOnlyBadges(zone);
              }
            }
          } catch(e) {}
          _updateXelaTexts();
        }, 50);
      }
    });
    if (document.body) {
      _xelaObserver.observe(document.body, { childList: true, subtree: true });
    } else {
      document.addEventListener('DOMContentLoaded', function() {
        _xelaObserver.observe(document.body, { childList: true, subtree: true });
      });
    }
  }

  document.addEventListener('cv:location-changed', function(e) {
    if (e.detail) applyXelaBadgeLogic(e.detail);
  });
  document.addEventListener('cv:location-ready', function(e) {
    if (e.detail) applyXelaBadgeLogic(e.detail);
  });

  (function() {
    try {
      var match = document.cookie.match('(?:^|;)\\s*' + COOKIE_NAME + '=([^;]*)');
      if (match) {
        var d = JSON.parse(decodeURIComponent(match[1]));
        if (d && d.confirmed) {
          document.documentElement.classList.add('cv-has-location');
          if (d.precise) document.documentElement.classList.add('cv-has-exact-location');
          if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', function() { applyXelaBadgeLogic(d); });
          } else {
            applyXelaBadgeLogic(d);
          }
        }
      }
    } catch(e) {}
  })();
  var DEFAULT_LOCATION = {
    dept: 'Guatemala',
    muni: 'Guatemala',
    lat: 14.6349,
    lng: -90.5069,
    zone: 'messenger_ciudad'
  };

  var DAYS_ES = ['domingo','lunes','martes','miércoles','jueves','viernes','sábado'];
  var MONTHS_ES = ['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'];

  function getNowGT() {
    var now = new Date();
    var utc = now.getTime() + now.getTimezoneOffset() * 60000;
    return new Date(utc + GT_OFFSET * 3600000);
  }

  function pointInPolygon(point, polygon) {
    var x = point[0], y = point[1];
    var inside = false;
    for (var i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
      var xi = polygon[i][0], yi = polygon[i][1];
      var xj = polygon[j][0], yj = polygon[j][1];
      var intersect = ((yi > y) !== (yj > y)) && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
      if (intersect) inside = !inside;
    }
    return inside;
  }

  function pointInGeometry(lng, lat, geometry) {
    var point = [lng, lat];
    if (geometry.type === 'Polygon') {
      return pointInPolygon(point, geometry.coordinates[0]);
    } else if (geometry.type === 'MultiPolygon') {
      for (var p = 0; p < geometry.coordinates.length; p++) {
        if (pointInPolygon(point, geometry.coordinates[p][0])) return true;
      }
    }
    return false;
  }

  var geoCache = {};

  function loadGeoJSON(url) {
    if (geoCache[url]) return Promise.resolve(geoCache[url]);
    return fetch(url)
      .then(function(r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function(data) {
        geoCache[url] = data;
        return data;
      });
  }

  function findCityZone(lat, lng, config) {
    var urls = config.geoJsonUrls;
    if (!urls.zonasCiudad) return Promise.resolve(null);
    return loadGeoJSON(urls.zonasCiudad).then(function(data) {
      for (var i = 0; i < data.features.length; i++) {
        var feat = data.features[i];
        if (pointInGeometry(lng, lat, feat.geometry)) {
          return feat.properties.name || null;
        }
      }
      return null;
    }).catch(function() { return null; });
  }

  function findDeliveryZone(lat, lng, config) {
    var urls = config.geoJsonUrls;
    return Promise.all([
      loadGeoJSON(urls.zonaMensajero),
      loadGeoJSON(urls.zonaXela),
      loadGeoJSON(urls.municipios)
    ]).then(function(results) {
      var zonaMensajero = results[0];
      var zonaXela = results[1];
      var municipios = results[2];

      var inMensajero = false;
      for (var i = 0; i < zonaMensajero.features.length; i++) {
        if (pointInGeometry(lng, lat, zonaMensajero.features[i].geometry)) {
          inMensajero = true;
          break;
        }
      }

      var inXela = false;
      for (var i = 0; i < zonaXela.features.length; i++) {
        if (pointInGeometry(lng, lat, zonaXela.features[i].geometry)) {
          inXela = true;
          break;
        }
      }

      var municipio = null;
      var departamento = null;
      for (var i = 0; i < municipios.features.length; i++) {
        var feat = municipios.features[i];
        if (pointInGeometry(lng, lat, feat.geometry)) {
          municipio = feat.properties.municipio || feat.properties.MUNICIPIO || '';
          departamento = feat.properties.departamen || feat.properties.DEPARTAMEN || feat.properties.departamento || '';
          break;
        }
      }

      if (!municipio && !inMensajero && !inXela) {
        return { zone: 'outside', municipio: null, departamento: null, cityZone: null };
      }

      if (inMensajero) {
        var isGuatemalaCity = municipio && municipio.toLowerCase() === 'guatemala';
        if (isGuatemalaCity) {
          return findCityZone(lat, lng, config).then(function(cityZone) {
            return {
              zone: 'messenger_ciudad',
              municipio: municipio,
              departamento: departamento,
              cityZone: cityZone
            };
          });
        }
        return {
          zone: 'messenger',
          municipio: municipio,
          departamento: departamento,
          cityZone: null
        };
      }

      if (inXela) {
        return {
          zone: 'messenger_xela',
          municipio: municipio,
          departamento: departamento,
          cityZone: null
        };
      }

      return {
        zone: 'cargo_expreso',
        municipio: municipio,
        departamento: departamento,
        cityZone: null
      };
    });
  }

  function getCentroid(geometry) {
    var coords;
    if (geometry.type === 'Polygon') {
      coords = geometry.coordinates[0];
    } else if (geometry.type === 'MultiPolygon') {
      coords = geometry.coordinates[0][0];
    } else {
      return null;
    }
    var sumLng = 0, sumLat = 0;
    for (var i = 0; i < coords.length; i++) {
      sumLng += coords[i][0];
      sumLat += coords[i][1];
    }
    return [sumLat / coords.length, sumLng / coords.length];
  }

  function isValidTime(str) {
    if (!str || str === 'cerrado') return false;
    var parts = str.split(':');
    if (parts.length !== 2) return false;
    var h = parseInt(parts[0], 10);
    var m = parseInt(parts[1], 10);
    return !isNaN(h) && !isNaN(m) && h >= 0 && h <= 23 && m >= 0 && m <= 59;
  }

  function parseBusinessHours(config) {
    var days = ['sun','mon','tue','wed','thu','fri','sat'];
    var hours = {};
    for (var i = 0; i < days.length; i++) {
      var d = days[i];
      var open = config.hours[d + '_open'] || '';
      var close = config.hours[d + '_close'] || '';
      if (isValidTime(open) && isValidTime(close)) {
        hours[i] = {
          open: parseTime(open),
          close: parseTime(close)
        };
      } else {
        hours[i] = null;
      }
    }
    return hours;
  }

  function parseTime(str) {
    var parts = str.split(':');
    return { h: parseInt(parts[0], 10), m: parseInt(parts[1], 10) };
  }

  function timeToMinutes(t) {
    return t.h * 60 + t.m;
  }

  function isBusinessDay(date, bh) {
    return bh[date.getDay()] !== null;
  }

  function addBusinessDays(date, days, bh) {
    var result = new Date(date.getTime());
    result.setHours(0, 0, 0, 0);
    var added = 0;
    while (added < days) {
      result.setDate(result.getDate() + 1);
      if (isBusinessDay(result, bh)) added++;
    }
    return result;
  }

  function nextBusinessOpen(date, bh, cutoff) {
    cutoff = cutoff || 0;
    var d = new Date(date.getTime());
    var dayInfo = bh[d.getDay()];
    if (dayInfo) {
      var nowMin = d.getHours() * 60 + d.getMinutes();
      var effectiveClose = timeToMinutes(dayInfo.close) - cutoff;
      if (nowMin < effectiveClose) {
        if (nowMin >= timeToMinutes(dayInfo.open)) {
          return d;
        } else {
          d.setHours(dayInfo.open.h, dayInfo.open.m, 0, 0);
          return d;
        }
      }
    }
    d.setDate(d.getDate() + 1);
    d.setHours(0, 0, 0, 0);
    for (var attempt = 0; attempt < 14; attempt++) {
      var info = bh[d.getDay()];
      if (info) {
        d.setHours(info.open.h, info.open.m, 0, 0);
        return d;
      }
      d.setDate(d.getDate() + 1);
    }
    return d;
  }

  function calculateEstimate(zoneInfo, productType, config, now) {
    if (!now) now = getNowGT();
    var bh = parseBusinessHours(config);
    var cutoff = parseInt(config.cutoff, 10) || 0;
    var baseDate = new Date(now.getTime());

    if (productType === 'backorder') {
      baseDate = addBusinessDays(now, 7, bh);
      baseDate.setHours(now.getHours(), now.getMinutes(), 0, 0);
    } else if (productType === 'slowback') {
      baseDate = addBusinessDays(now, 10, bh);
      baseDate.setHours(now.getHours(), now.getMinutes(), 0, 0);
    }

    var zone = zoneInfo.zone;
    var result = {};

    if (productType === 'xela') {
      if (zone === 'messenger_xela') {
        var minutes = parseInt(config.minutes.messenger_xela, 10) || 60;
        var dispatchDate = nextBusinessOpen(baseDate, bh, cutoff);
        var deliveryTime = new Date(dispatchDate.getTime() + minutes * 60000);
        result.method = 'Mensajero';
        result.date = deliveryTime;
        result.type = 'messenger';
      } else {
        var dispatchDate = nextBusinessOpen(baseDate, bh, cutoff);
        var arrivalDate = addBusinessDays(dispatchDate, 1, bh);
        var dayInfo = bh[arrivalDate.getDay()];
        if (dayInfo) {
          arrivalDate.setHours(dayInfo.open.h, dayInfo.open.m, 0, 0);
        }
        result.method = 'Cargo Expreso';
        result.date = arrivalDate;
        result.type = 'cargo';
      }
    } else {
      if (zone === 'messenger_ciudad') {
        var minutes = parseInt(config.minutes.messenger_ciudad, 10) || 60;
        var dispatchDate = nextBusinessOpen(baseDate, bh, cutoff);
        var deliveryTime = new Date(dispatchDate.getTime() + minutes * 60000);
        result.method = 'Mensajero';
        result.date = deliveryTime;
        result.type = 'messenger';
      } else if (zone === 'messenger') {
        var minutes = parseInt(config.minutes.messenger, 10) || 90;
        var dispatchDate = nextBusinessOpen(baseDate, bh, cutoff);
        var deliveryTime = new Date(dispatchDate.getTime() + minutes * 60000);
        result.method = 'Mensajero';
        result.date = deliveryTime;
        result.type = 'messenger';
      } else if (zone === 'messenger_xela') {
        var dispatchDate = nextBusinessOpen(baseDate, bh, cutoff);
        var arrivalDate = addBusinessDays(dispatchDate, 1, bh);
        var dayInfo = bh[arrivalDate.getDay()];
        if (dayInfo) {
          arrivalDate.setHours(dayInfo.open.h, dayInfo.open.m, 0, 0);
        }
        result.method = 'Cargo Expreso';
        result.date = arrivalDate;
        result.type = 'cargo';
      } else if (zone === 'cargo_expreso') {
        var dispatchDate = nextBusinessOpen(baseDate, bh, cutoff);
        var arrivalDate = addBusinessDays(dispatchDate, 1, bh);
        var dayInfo = bh[arrivalDate.getDay()];
        if (dayInfo) {
          arrivalDate.setHours(dayInfo.open.h, dayInfo.open.m, 0, 0);
        }
        result.method = 'Cargo Expreso';
        result.date = arrivalDate;
        result.type = 'cargo';
      } else {
        return null;
      }
    }

    var locLabel = zoneInfo.cityZone || zoneInfo.municipio || '';
    if (locLabel) locLabel = shortenMuniName(locLabel);
    result.formatted = formatDate(result.date, result.type, locLabel);
    result.municipio = zoneInfo.municipio;
    result.departamento = zoneInfo.departamento;
    return result;
  }

  function shortenMuniName(name) {
    if (!name) return name;
    var s = name;
    s = s.replace(/^(El|La)\s+/i, '');
    s = s.replace(/\bSanta\s+/g, 'Sta. ');
    s = s.replace(/\bSanto\s+/g, 'Sto. ');
    s = s.replace(/\bSan\s+/g, 'S. ');
    var words = {
      'Pedro':'P.','José':'J.','Jose':'J.','Juan':'J.','Marcos':'M.',
      'Pablo':'P.','Francisco':'F.','Miguel':'M.','Antonio':'A.',
      'Martín':'M.','Martin':'M.','Lucas':'L.','Bartolomé':'B.',
      'Bartolome':'B.','Cristóbal':'C.','Cristobal':'C.','Andrés':'A.',
      'Andres':'A.','Mateo':'M.','Felipe':'F.','Bernardino':'B.',
      'Agustín':'A.','Agustin':'A.','Raymundo':'R.','Benito':'B.'
    };
    Object.keys(words).forEach(function(w) {
      s = s.replace(new RegExp('\\b' + w + '\\b', 'g'), words[w]);
    });
    return s.replace(/\s{2,}/g, ' ').trim();
  }

  function formatDate(date, type, locationLabel) {
    var now = getNowGT();
    var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    var dateDay = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    var diffDays = Math.round((dateDay - today) / 86400000);

    var dayName;
    if (diffDays === 0) {
      dayName = 'hoy';
    } else if (diffDays === 1) {
      dayName = 'mañana';
    } else if (diffDays === 2) {
      dayName = 'pasado mañana, ' + DAYS_ES[date.getDay()];
    } else {
      dayName = 'el ' + DAYS_ES[date.getDay()] + ' ' + date.getDate() + ' de ' + MONTHS_ES[date.getMonth()];
    }

    var suffix = locationLabel ? ' en ' + locationLabel : '';

    if (type === 'messenger' && diffDays <= 1) {
      var hours = date.getHours();
      var mins = date.getMinutes();
      var ampm = hours >= 12 ? 'PM' : 'AM';
      var h12 = hours % 12;
      if (h12 === 0) h12 = 12;
      var timeStr = h12 + ':' + (mins < 10 ? '0' : '') + mins + ' ' + ampm;
      return 'Recíbelo ' + dayName + ' a las ' + timeStr + suffix;
    } else {
      return 'Recíbelo ' + dayName + suffix;
    }
  }

  function setCookie(name, value, days) {
    var expires = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + encodeURIComponent(JSON.stringify(value)) + expires + '; path=/; SameSite=Lax';
  }

  function getCookie(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i].trim();
      if (c.indexOf(nameEQ) === 0) {
        try {
          return JSON.parse(decodeURIComponent(c.substring(nameEQ.length)));
        } catch(e) {
          return null;
        }
      }
    }
    return null;
  }

  function fireLocationEvent(locationData) {
    var evt;
    try {
      evt = new CustomEvent('cv:location-ready', { detail: locationData });
    } catch(e) {
      evt = document.createEvent('CustomEvent');
      evt.initCustomEvent('cv:location-ready', true, true, locationData);
    }
    document.dispatchEvent(evt);
  }

  function fireLocationChangeEvent(locationData) {
    var evt;
    try {
      evt = new CustomEvent('cv:location-changed', { detail: locationData });
    } catch(e) {
      evt = document.createEvent('CustomEvent');
      evt.initCustomEvent('cv:location-changed', true, true, locationData);
    }
    document.dispatchEvent(evt);
  }

  var CelovendoLocation = {
    _config: null,
    _location: null,
    _deptMuniList: null,
    _ready: false,

    getConfig: function() {
      if (this._config) return this._config;
      var el = document.getElementById('cv-location-config');
      if (!el) return null;
      try {
        this._config = JSON.parse(el.textContent);
        return this._config;
      } catch(e) {
        return null;
      }
    },

    getLocation: function() {
      if (this._location) return this._location;
      this._location = getCookie(COOKIE_NAME);
      return this._location;
    },

    setLocation: function(dept, muni, lat, lng, zone, cityZone, confirmed, precise) {
      var loc = { dept: dept, muni: muni, lat: lat, lng: lng, zone: zone || '' };
      if (cityZone) {
        loc.cityZone = cityZone;
      } else if (cityZone === undefined && this._location && this._location.cityZone &&
                 this._location.dept === dept && this._location.muni === muni) {
        loc.cityZone = this._location.cityZone;
      }
      loc.confirmed = (confirmed !== undefined) ? !!confirmed : true;
      // precise === true sólo cuando la ubicación viene de GPS o de un pin exacto
      // en el mapa. El selector de depto/municipio del header NO la pasa.
      loc.precise = !!precise;
      this._location = loc;
      setCookie(COOKIE_NAME, loc, COOKIE_DAYS);
      if (loc.confirmed) {
        this._applyLocationBodyClass();
      }
      fireLocationChangeEvent(loc);
      this._updateHeaderBadge(loc, loc.confirmed);
      applyXelaBadgeLogic(loc);
      return loc;
    },

    _shortenMuniName: function(name) {
      return shortenMuniName(name);
    },

    _updateHeaderBadge: function(loc, animate) {
      var badgeText = document.querySelector('.capital-badge__text');
      var badge = document.querySelector('.capital-badge');
      var desc = document.getElementById('header-location-desc');
      var pill = document.getElementById('header-location-pill');
      var pillText = pill ? pill.querySelector('.header-location-panel__pill-text') : null;
      if (loc.confirmed) {
        var raw = loc.cityZone || loc.muni || 'Guatemala';
        var shortened = this._shortenMuniName(raw);
        if (badgeText) badgeText.textContent = shortened;
        if (badge) {
          badge.classList.remove('capital-badge--unconfirmed');
          if (animate) {
            badge.classList.remove('capital-badge--location-confirmed');
            void badge.offsetWidth;
            badge.classList.add('capital-badge--location-confirmed');
            setTimeout(function() { badge.classList.remove('capital-badge--location-confirmed'); }, 2200);
          }
        }
        if (desc) desc.style.display = 'none';
        if (pill) { pill.style.display = ''; if (pillText) pillText.textContent = shortened; }
      } else {
        if (badgeText) badgeText.textContent = 'Tu ubicación';
        if (badge) badge.classList.add('capital-badge--unconfirmed');
        if (desc) desc.style.display = '';
        if (pill) pill.style.display = 'none';
      }
    },

    loadDeptMuniList: function() {
      var self = this;
      if (this._deptMuniList) return Promise.resolve(this._deptMuniList);
      var config = this.getConfig();
      if (!config) return Promise.resolve({});
      return fetch(config.geoJsonUrls.deptMuniList)
        .then(function(r) { return r.json(); })
        .then(function(data) {
          self._deptMuniList = data;
          return data;
        })
        .catch(function() {
          self._deptMuniList = {};
          return {};
        });
    },

    resolveFromCoords: function(lat, lng) {
      var config = this.getConfig();
      if (!config) return Promise.reject('No config');
      return findDeliveryZone(lat, lng, config).then(function(zoneInfo) {
        var result = {
          dept: zoneInfo.departamento || DEFAULT_LOCATION.dept,
          muni: zoneInfo.municipio || DEFAULT_LOCATION.muni,
          lat: lat,
          lng: lng,
          zone: zoneInfo.zone
        };
        if (zoneInfo.cityZone) result.cityZone = zoneInfo.cityZone;
        return result;
      });
    },

    resolveFromMuni: function(dept, muni) {
      var config = this.getConfig();
      if (!config) return Promise.reject('No config');
      return loadGeoJSON(config.geoJsonUrls.municipios).then(function(data) {
        var feature = null;
        for (var i = 0; i < data.features.length; i++) {
          var f = data.features[i];
          var fMuni = (f.properties.municipio || f.properties.MUNICIPIO || '').toLowerCase();
          var fDept = (f.properties.departamen || f.properties.DEPARTAMEN || f.properties.departamento || '').toLowerCase();
          if (fMuni === muni.toLowerCase() && fDept === dept.toLowerCase()) {
            feature = f;
            break;
          }
        }
        if (feature) {
          var centroid = getCentroid(feature.geometry);
          var lat = centroid ? centroid[0] : DEFAULT_LOCATION.lat;
          var lng = centroid ? centroid[1] : DEFAULT_LOCATION.lng;
          return findDeliveryZone(lat, lng, config).then(function(zoneInfo) {
            var zone = zoneInfo.zone;
            if (zone === 'outside' || !zone) zone = 'cargo_expreso';
            var result = {
              dept: dept,
              muni: muni,
              lat: lat,
              lng: lng,
              zone: zone
            };
            if (zoneInfo.cityZone) result.cityZone = zoneInfo.cityZone;
            return result;
          });
        }
        return { dept: dept, muni: muni, lat: DEFAULT_LOCATION.lat, lng: DEFAULT_LOCATION.lng, zone: 'cargo_expreso' };
      });
    },

    _showLocationPopup: function() {
      try { if (sessionStorage.getItem('cv_location_popup_shown')) return false; } catch(e) {}
      var pageViews = 1;
      try {
        pageViews = parseInt(sessionStorage.getItem('cv_page_views') || '0', 10) + 1;
        sessionStorage.setItem('cv_page_views', String(pageViews));
      } catch(e) {}
      if (pageViews < 2) return false;
      try { sessionStorage.setItem('cv_location_popup_shown', '1'); } catch(e) {}
      if (window._cvLocPopupOpen) {
        window._cvLocPopupOpen();
      }
      return true;
    },

    _hideLocationPopup: function() {
      var overlay = document.getElementById('cv-location-popup-overlay');
      if (overlay) {
        overlay.style.display = 'none';
        overlay.setAttribute('aria-hidden', 'true');
      }
    },

    _showDeniedState: function() {
      if (window._cvLocShowDenied) {
        window._cvLocShowDenied();
      }
    },

    requestGeolocation: function() {
      var self = this;
      return new Promise(function(resolve) {
        if (!navigator.geolocation) {
          var loc = self.setLocation(DEFAULT_LOCATION.dept, DEFAULT_LOCATION.muni, DEFAULT_LOCATION.lat, DEFAULT_LOCATION.lng, DEFAULT_LOCATION.zone, undefined, false);
          resolve(loc);
          return;
        }
        navigator.geolocation.getCurrentPosition(function(pos) {
          var lat = pos.coords.latitude;
          var lng = pos.coords.longitude;
          self.resolveFromCoords(lat, lng).then(function(locData) {
            if (locData.zone === 'outside') {
              var loc = self.setLocation(DEFAULT_LOCATION.dept, DEFAULT_LOCATION.muni, DEFAULT_LOCATION.lat, DEFAULT_LOCATION.lng, DEFAULT_LOCATION.zone, undefined, false);
              resolve(loc);
            } else {
              var loc = self.setLocation(locData.dept, locData.muni, locData.lat, locData.lng, locData.zone, locData.cityZone, true, true);
              resolve(loc);
            }
          }).catch(function() {
            var loc = self.setLocation(DEFAULT_LOCATION.dept, DEFAULT_LOCATION.muni, DEFAULT_LOCATION.lat, DEFAULT_LOCATION.lng, DEFAULT_LOCATION.zone, undefined, false);
            resolve(loc);
          });
        }, function(err) {
          if (err && err.code === 1) {
            self._showDeniedState();
          }
          var loc = self.setLocation(DEFAULT_LOCATION.dept, DEFAULT_LOCATION.muni, DEFAULT_LOCATION.lat, DEFAULT_LOCATION.lng, DEFAULT_LOCATION.zone, undefined, false);
          resolve(loc);
        }, { enableHighAccuracy: false, timeout: 10000 });
      });
    },

    calculateEstimate: function(productType) {
      var loc = this.getLocation();
      var config = this.getConfig();
      if (!loc || !loc.confirmed || !config) return null;
      var zoneInfo = { zone: loc.zone, municipio: loc.muni, departamento: loc.dept, cityZone: loc.cityZone };
      return calculateEstimate(zoneInfo, productType, config);
    },

    _applyLocationBodyClass: function() {
      document.documentElement.classList.add('cv-has-location');
      applyExactLocationClass(this._location);
    },

    _ensureCityZone: function() {
      var self = this;
      var loc = this.getLocation();
      if (!loc || !loc.confirmed || loc.zone !== 'messenger_ciudad' || loc.cityZone || !loc.lat || !loc.lng) return;
      var config = this.getConfig();
      if (!config) return;
      findCityZone(loc.lat, loc.lng, config).then(function(cityZone) {
        if (cityZone) {
          self.setLocation(loc.dept, loc.muni, loc.lat, loc.lng, loc.zone, cityZone, true, loc.precise);
        }
      });
    },

    init: function() {
      var self = this;
      var existing = this.getLocation();
      if (existing && existing.dept && existing.muni && existing.confirmed) {
        this._ready = true;
        this._applyLocationBodyClass();
        this._updateHeaderBadge(existing);
        fireLocationEvent(existing);
        this._ensureCityZone();
      } else {
        var shown = this._showLocationPopup();
        if (!shown) {
          var loc = { dept: DEFAULT_LOCATION.dept, muni: DEFAULT_LOCATION.muni, lat: DEFAULT_LOCATION.lat, lng: DEFAULT_LOCATION.lng, zone: DEFAULT_LOCATION.zone, confirmed: false };
          self._location = loc;
          self._updateHeaderBadge(loc);
          fireLocationEvent(loc);
          self._ready = true;
        }
      }
    }
  };

  CelovendoLocation._defaultLocation = DEFAULT_LOCATION;
  window.CelovendoLocation = CelovendoLocation;
  window.CelovendoGeo = {
    pointInPolygon: pointInPolygon,
    pointInGeometry: pointInGeometry,
    loadGeoJSON: loadGeoJSON,
    findDeliveryZone: findDeliveryZone,
    getCentroid: getCentroid,
    calculateEstimate: calculateEstimate,
    formatDate: formatDate,
    getNowGT: getNowGT,
    parseBusinessHours: parseBusinessHours,
    nextBusinessOpen: nextBusinessOpen,
    addBusinessDays: addBusinessDays
  };

  document.addEventListener('DOMContentLoaded', function() {
    CelovendoLocation.init();
  });
})();
